import { captureStack1fzi4aczwc4hg as captureStack } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlinx_io_IOException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.d4i_1);
}
var IOExceptionClass;
function IOException() {
  if (IOExceptionClass === VOID) {
    class $ extends Exception() {
      static e4i() {
        var $this = this.wd();
        init_kotlinx_io_IOException($this);
        return $this;
      }
      static f4i(message) {
        var $this = this.xd(message);
        init_kotlinx_io_IOException($this);
        return $this;
      }
      static g4i(message, cause) {
        var $this = this.yd(message, cause);
        init_kotlinx_io_IOException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IOException', $.e4i);
    IOExceptionClass = $;
  }
  return IOExceptionClass;
}
function init_kotlinx_io_EOFException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.j4f_1);
}
var EOFExceptionClass;
function EOFException() {
  if (EOFExceptionClass === VOID) {
    class $ extends IOException() {
      static h4i() {
        var $this = this.e4i();
        init_kotlinx_io_EOFException($this);
        return $this;
      }
      static k4f(message) {
        var $this = this.f4i(message);
        init_kotlinx_io_EOFException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'EOFException', $.h4i);
    EOFExceptionClass = $;
  }
  return EOFExceptionClass;
}
//region block: exports
export {
  EOFException as EOFExceptionh831u25jcq9n,
  IOException as IOException1wyutdmfe71nu,
};
//endregion

//# sourceMappingURL=-PlatformJs.mjs.map
